import React from "react";

const IconKey = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 10.623 11.328">
      <g id="Group_2616" dananame="Group 2616" transform="translate(0.707)">
        <path
          id="Path_9983"
          dananame="Path 9983"
          d="M9697.084-16249.053l4.178-4.178"
          transform="translate(-9697.084 16259)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <g
          id="Ellipse_309"
          dananame="Ellipse 309"
          transform="translate(2.916)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        >
          <circle cx="3.5" cy="3.5" r="3" fill="none" />
        </g>
        <path
          id="Path_9984"
          dananame="Path 9984"
          d="M9697.348-16249.314l1.094,1.094.252.252"
          transform="translate(-9696.604 16258.59)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_9985"
          dananame="Path 9985"
          d="M9697.348-16249.315l.617.617.143.143"
          transform="translate(-9694.872 16257.172)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconKey;
